"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sectionWrapperClass = sectionWrapperClass;

// Generated sections are styled by the theme, not the template CSS.
function sectionWrapperClass(_ref) {
  var template = _ref.template,
      rootKey = _ref.rootKey,
      layoutVersionKey = _ref.layoutVersionKey;
  var sectionClass = 'section-' + rootKey;
  return layoutVersionKey ? sectionClass : template + '-template ' + sectionClass;
}